import React, { useEffect, useState } from 'react';
import { StyledImage, StyledWrapper } from './style';
import { API_SOCIAL } from '../../../constants/api';
import request from '../../../utils/api';

const CustomWidget = () => {
  const [image, setImage] = useState();
  useEffect(() => {
    request(`${API_SOCIAL}widget/home`, {
      params: '',
      method: 'GET'
    }).then(response => {
      response.map(el => {
        if (el.type === 'customWidget') {
          setImage(el.icon);
        }
        return image;
      });
    });
  }, []);
  return (
    <StyledWrapper>
      {image ? <StyledImage src={image} /> : 'Cargando'}
    </StyledWrapper>
  );
};

export default CustomWidget;
